import { countryToShortenedStateMap, countryMapToShortened } from 'shared/constants/cities-geography';
/**
 *
 * @param {string} state - ISO code or full name
 * @param {string} country - full name (i.e. 'United States')
 * @returns string
 */ export var getShortStateName = function(state, country) {
    var _countryToShortenedStateMap_country;
    if (country === 'Puerto Rico') {
        return 'PR';
    }
    // ISO codes for states can be up to 3 characters
    if (state.length <= 3) {
        return state;
    }
    return (_countryToShortenedStateMap_country = countryToShortenedStateMap[country]) === null || _countryToShortenedStateMap_country === void 0 ? void 0 : _countryToShortenedStateMap_country[state];
};
/**
 *
 * @param {string} state - ISO code (i.e. 'OR')
 * @param {string} country - full name (i.e. 'United States')
 * @returns string
 */ export var getShortCountryName = function(state, country) {
    return state === 'PR' ? 'US' : countryMapToShortened[country];
};
export var normalizeCountryCode = function(country) {
    var _countryMapToShortened_country;
    return (_countryMapToShortened_country = countryMapToShortened[country]) !== null && _countryMapToShortened_country !== void 0 ? _countryMapToShortened_country : country;
};
